export default __webpack_public_path__ + "static/media/ls1_g01.cee4b523.png";